import { DeployerGridWebComponent } from '../component/DeployerGridWebComponent';
import { templatePackages } from '../view/template';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../../framework/BaseWebComponentController';
import { DeployerGridView } from '../view/DeployerGridView';
import { DeployerGridRepository } from '../repository/DeployerGridRepository';
import { GridEvents } from '../../../../grid/types/common';
import { State } from '../../../../grid/uiElements/inlineRowActions/types';
import { ToastActionConfig } from '../../../../configurationProfilesApp/exclusionsPanel/types';
import { GzToastNotificationWebComponent } from '../../../../ui/gzToastNotification';
import { ToastSeverity } from '../../../../ui/gzToastNotification/type';
import { InlineRowActionsWebComponent } from '../../../../grid/uiElements/inlineRowActions';
import { DeployerGridEvents } from '../types';
import { translateFn } from '../../../../utils/translator.helper';

export class DeployerGridController extends BaseWebComponentController {
  public component: DeployerGridWebComponent;
  public view: DeployerGridView;
  public viewConstructor: typeof DeployerGridView;

  public dataRepository: DeployerGridRepository;
  public dataRepositoryConstructor: typeof DeployerGridRepository;

  constructor(component: DeployerGridWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: DeployerGridView,
      viewTemplate: templatePackages,
      dataRepositoryConstructor: DeployerGridRepository,
    });
  }

  private static showErrorToast(errorMessage: string, actionConfig?: ToastActionConfig): void {
    let config = {};

    if (actionConfig) {
      config = {
        hasAction: true,
        ...actionConfig,
      };
    }

    GzToastNotificationWebComponent.buildToastWrapperElement({
      message: errorMessage,
      severity: ToastSeverity.ERROR,
      ...config,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$grid,
        event: GridEvents.EDIT_ROW_SAVE,
        callback: this.onEditGridRowSave,
      },
      {
        element: this.view.dom.$grid,
        event: GridEvents.ROW_CLICKED,
        callback: this.emitSelectionInForm,
      },
    ];
  }

  private emitSelectionInForm(event: WebComponentEvent): void {
    this.view.dom.$wrapper.dispatchEvent(
      new CustomEvent(DeployerGridEvents.ROW_SELECTED_EVENT, {
        bubbles: true,
        composed: true,
        detail: {
          valid: event.detail.rowDetails !== undefined,
          selectedRelayName: event.detail.rowDetails !== undefined ? event.detail.rowDetails.name : null,
          selectedRelayIP: event.detail.rowDetails !== undefined ? event.detail.rowDetails.ip : null,
          selectedRelayId: event.detail.rowDetails !== undefined ? event.detail.rowDetails._id : null,
          selectedRelayCustomHostname:
            event.detail.rowDetails !== undefined ? event.detail.rowDetails.customHostname : null,
        },
      })
    );
  }

  private async onEditGridRowSave(event: WebComponentEvent): Promise<void> {
    const { customHostname: newcustomHostname } = event.detail.newData.item;
    const { customHostname: oldcustomHostname } = event.detail.rowData.item;
    const currentRowIndex = event.detail.rowData.index;

    const inlineMenu = this.view.dom.$grid.controller?.view.getRowInlineMenu(
      currentRowIndex + 2
    ) as InlineRowActionsWebComponent;

    if (newcustomHostname === oldcustomHostname) {
      inlineMenu.state = State.SUCCESS;
      return;
    }

    try {
      inlineMenu.state = State.LOADING;
      inlineMenu.disabled = true;

      await this.dataRepository.updateSupaMachines([event.detail.newData.item]);
      this.view.dom.$grid.setRowData(currentRowIndex, event.detail.newData.item);

      await this.reloadGrid();

      inlineMenu.disabled = false;
      // we need to wait for state property on inlineMenu to once again exist
      setTimeout(() => {
        inlineMenu.state = State.SUCCESS;
      }, 1000);
    } catch (e) {
      inlineMenu.disabled = false;
      inlineMenu.state = State.ERROR;

      const errorMessage =
        e?.err.exceptionType && e?.err.exceptionType === 'DAL\\Exceptions\\TargetsException'
          ? translateFn('Failed to edit relay due to an internal service error.')
          : translateFn('Package deployer error');

      DeployerGridController.showErrorToast(errorMessage);
    }
  }

  public async reloadGrid(): Promise<void> {
    await this.view.dom.$grid?.controller?.handleGridItemsLoad();
  }
}
